import React from "react";
import { Link } from "react-router-dom";

const ContactHero = () => {
  return (
    <div
      className="breadcumb-wrapper"
      style={{
        backgroundImage: "url('/assets/image/clean7.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "350px", // or any desired height
        display: "flex",
        alignItems: "flex-end", // this pushes content to the bottom
        paddingBottom: "30px", // space from bottom edge
      }}
    >
      <div className="container">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title">Contact Us</h1>
          <ul className="breadcumb-menu">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>Contact</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ContactHero;
